import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import "leaflet/dist/leaflet.css";
import { TitleBar } from "../../Components/Common/TitleBar/titleBar";

import CountUp from "react-countup";
import { UserManagementList } from "./UserManagementList";
import { RevenueGraph } from "./RevenueGraph";
import { fetchAdminDashboard } from "../../slices/adminDashboardDetails/thunk";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const DashboardAccounting = () => {
  document.title = "Dashboard - Accounting | D&A ";
  const dispatch = useDispatch();
  const dashboard = useSelector((state) => state.Dashboard);
  console.log("dashboard222", dashboard);
  

  useEffect(() => {
    dispatch(fetchAdminDashboard());
  }, [dispatch]);

  const dashboardCards = [
    { title: "Total Revenue", count: parseFloat(dashboard.totalRevenue) || 0 },
    {
      title: "Total Expenses",
      count: parseFloat(dashboard.totalExpenses) || 0,
    },
    { title: "Net Profit", count: parseFloat(dashboard.netProfit) || 0 },
    {
      title: "Pending Salaries",
      count: parseFloat(dashboard.pendingSalaries) || 0,
    },
    { title: "Total Drivers", count: dashboard.totalDrivers || 0 },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex flex-column gap-3">
            <TitleBar title="Administration and Accounting" />

            <div className="dashbaord-card-container">
              {dashboardCards.map((element, index) => {
                return (
                  <Card key={index} className="card-animate dashboardCard mb-0">
                    <CardBody>
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="mb-0 dashboardCardTitle">
                            {element.title}
                          </p>
                          <h2 className="mt-4  fw-semibold dashboardCardCount">
                            <span className="counter-value">
                              {" "}
                              {index < 5 && "£"}
                              <CountUp
                                start={0}
                                end={element.count}
                                duration={4}
                              />
                            </span>
                          </h2>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                );
              })}
            </div>

            <div
              className="real-time-container"
              style={{ height: "auto", width: "100%" }}
            >
              <Row className="flex-column flex-xl-row h-100">
                {/* Map first on mobile, second on desktop */}
                <Col
                  xs={12}
                  xl={6}
                  className="order-1 order-xl-2 mb-3 mb-xl-0"
                  style={{
                    minHeight: 300,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <TitleBar title="Revenue and Expenses (Monthly)" />
                  <RevenueGraph />
                </Col>

                <Col
                  xs={12}
                  xl={6}
                  className="order-2 order-xl-1"
                  style={{
                    minHeight: 300,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <TitleBar title="User Management" />
                  <UserManagementList />
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardAccounting;
